module.exports = __webpack_public_path__ + "static/img/evolucao-like-dislike-area.b92027d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-like-dislike-area.png
// module id = TlXe
// module chunks = 1